import React from 'react';
import styled from 'styled-components';
import Header from './Components/Header';
import { eonImages } from '../Theming/images';
import { Trans, useTranslation } from 'react-i18next';
import { themeColor } from '../Theming';
import { isAndroid } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { Path } from '../Routing';
import {
  ANALYTICS_PAGE_NAMES,
  trackClickedActionEvent,
} from '../Common/Analytics/utils';
import { usePageViewTracking, useQuery } from '../Common/Hooks';

const Container = styled.div`
  flex: 1;
  flex-direction: column;
  display: flex;
  max-height: 100dvh;
  max-width: 600px;
  margin: 0 auto;
`;

const EonLogo = styled.img`
  height: 48px;
`;

const InfoContainer = styled.div`
  padding: 10vh 9% 10px 9%;
`;

const InfoItem = styled.div`
  display: flex;
  flex-direction: row;

  & > img {
    height: 56px;
  }

  & > div {
    margin-left: 10px;
  }

  & h2 {
    font-size: 24px;
    color: ${themeColor('navyBlueText')};
    margin: 0 0 7px 0;
    font-family: Helvetica;
  }

  & h3 {
    color: ${themeColor('navyBlueText')};
    font-size: 14px;
    font-weight: 400;
    margin: 0;
    height: 61px;
    font-family: Helvetica;
  }
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex: 1;
  padding: 20px 0 50px 0;

  & > button {
    background-color: ${themeColor('navyBlueText')};
    height: 56px;
    margin: 50px 35px 0 35px;
    border-radius: 100px;
    color: ${themeColor('white')};
    font-size: 16px;
    font-weight: 700;
    font-family: Helvetica;
    border: none;
  }
`;

const PrivacyText = styled.div`
  p {
    color: ${themeColor('navyBlueText')};
    font-size: 12px;
    text-align: center;
    margin: 0;
    font-family: Helvetica;

    & > a {
      color: ${themeColor('navyBlueText')};
      text-decoration: underline;
      font-family: Helvetica;
    }
  }
`;

const EonActivation = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const query = useQuery();
  const infoItems = [
    { key: 'stayInformed', image: require('../Assets/Icons/card.png') },
    { key: 'shopAndSave', image: require('../Assets/Icons/hands.png') },
  ];
  const { landing_page } = ANALYTICS_PAGE_NAMES;
  usePageViewTracking(landing_page, 'Eon');

  const onActivateClick = () => {
    trackClickedActionEvent(query, 'Eon', 'activate', landing_page);
    if (isAndroid) {
      return navigate({
        pathname: Path.EonPluginAndroidAccessibility,
        search: location.search,
      });
    }
    navigate({
      pathname: Path.EonPluginActivationMultiStep,
      search: location.search,
    });
  };

  return (
    <Container>
      <Header
        height={'20vh'}
        titleContent={<EonLogo src={eonImages.eon_white} />}
      />
      <InfoContainer>
        {infoItems.map((item) => (
          <InfoItem key={item.key}>
            <img
              src={item.image}
              alt={item.key}
              style={{ marginRight: '8px' }}
            />
            <div>
              <h2>{t(`eon.${item.key}.title`)}</h2>
              <h3>{t(`eon.${item.key}.description`)}</h3>
            </div>
          </InfoItem>
        ))}
      </InfoContainer>
      <Footer>
        <PrivacyText>
          <Trans i18nKey="eon.privacyText" t={t}>
            <p>
              <a
                href="https://event.kindred.co/eon-privacy-policy"
                target="_blank"
                rel="noreferrer"
              >
                policy
              </a>
            </p>
          </Trans>
        </PrivacyText>
        <button onClick={onActivateClick}>{t('eon.activate')}</button>
      </Footer>
    </Container>
  );
};

export default EonActivation;
